module.exports = __webpack_public_path__ + "img/News_item_1.a81161db.jpg";